import { tokPx } from '@sunwebgroup/ui-components'
import { Accordion } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import * as React from 'react'
import { styled } from 'styled-components'
import { useIntl } from '@/intl'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'
import { DistanceToBeachFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/DistanceToBeachFilter'
import { DistanceToCenterFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/DistanceToCenterFilter'
import { MetersToSkiLiftFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/MetersToSkiLiftFilter'
import { MetersToSlopeFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/MetersToSlopeFilter'
import { FilterGroupProps } from '../../types'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${tokPx('components_form_spacing')};
  `
export function DistanceFilters({ defaultOpen }: FilterGroupProps) {
  const intl = useIntl()
  const { selectedValue: selectedMetersToBeachValue, options: toBeachOptions } = useSelectFilter('MetersToBeach')
  const { selectedValue: selectedMetersToCenterValue, options: toCenterOptions } = useSelectFilter('MetersToCenter')
  const { selectedValue: selectedMetersToSlopeValue, options: metersToSlopeOptions } = useSelectFilter('MetersToSlope')
  const { selectedValue: selectedMetersToSkiliftValue, options: metersToSkiLiftOptions }
    = useSelectFilter('MetersToSkiLift')

  if (
    isEmpty(metersToSlopeOptions)
    && isEmpty(metersToSkiLiftOptions)
    && isEmpty(toCenterOptions)
    && isEmpty(toBeachOptions)
  ) {
    return null
  }
  return (
    <Accordion.Item
      title={intl.formatMessage({ id: 'distance_to_interests_label' })}
      defaultOpen={
        selectedMetersToBeachValue !== null
        || selectedMetersToCenterValue !== null
        || selectedMetersToSlopeValue !== null
        || selectedMetersToSkiliftValue !== null
        || defaultOpen
      }
      data-qa="distance-filters"
    >
      <Wrapper>
        <DistanceToBeachFilter />
        <DistanceToCenterFilter />
        <MetersToSlopeFilter />
        <MetersToSkiLiftFilter />
      </Wrapper>
    </Accordion.Item>
  )
}
